export default {"src":"https://webcdn.trailways.com/_next/static/media/loader.5db686f3.gif","height":300,"width":394,"blurWidth":0,"blurHeight":0};